import script from "./PresenterView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PresenterView.vue?vue&type=script&lang=ts&setup=true"

import "./PresenterView.vue?vue&type=style&index=0&id=77a65275&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a65275"]])

export default __exports__